import './chip.scss';
import {FONT_COLOR} from "../fonts/font-props";
import {IconProps} from "../icons/icon-props-interface";
import Icon from "../icons/icon/icon";
import {Tooltip} from "../tooltip/tooltip";
import FontBody2 from '../fonts/font-body2/font-body2';
export enum CHIP_COLORS {
    DEFAULT = 'chip-default',
    GREEN = 'chip-green',
    BLUE = 'chip-blue',
    ORANGE = 'chip-orange',
    RED = 'chip-red',
    PURPLE = 'chip-purple',
    PENDING = 'chip-pending',
    APPROVED = 'chip-approved',
    CANCELLED = 'chip-cancelled',
    REJECTED = 'chip-rejected',
    DONE = 'chip-done',
    SHIPMENT_RECEIVED = 'chip-shipment-received',
    VALIDATED = 'chip-validated',
}

export interface IChipProps{
    label: string;
    color: CHIP_COLORS;
    icon?: React.FC<IconProps>;
    tooltip?: React.ReactNode;
}

const Chip: React.FC<IChipProps> = (({tooltip,color,icon,label}) => {
    let iconColor = getIconColor(color);
    let fontColor = getFontColor(color);
    const Chip = (
        <div className={'chip ' + color }>
            {icon ? <Icon Component={icon} color={iconColor}/> : ''}
            <FontBody2 color={fontColor}>{label}</FontBody2>
        </div>
    );
    if(tooltip){
        return (
            <Tooltip content={tooltip}>
                {Chip}
            </Tooltip>
        );
    }
    else {
        return Chip;
    }
});

function getIconColor(chipColor: CHIP_COLORS){
    switch(chipColor){
        case CHIP_COLORS.GREEN:
            return 'var(--color-semantic-1)';
        case CHIP_COLORS.BLUE:
            return 'var(--color-accent-1)';
        case CHIP_COLORS.ORANGE:
            return 'var(--color-accent-4)';
        case CHIP_COLORS.RED:
            return 'var(--color-accent-3)';
        case CHIP_COLORS.PURPLE:
            return 'var(--color-accent-2)';
        case CHIP_COLORS.PENDING:
            return 'var(--color-neutral-11-menu)';
        case CHIP_COLORS.APPROVED:
            return 'var(--color-neutral-11-menu)';
        case CHIP_COLORS.CANCELLED:
            return 'var(--color-neutral-11-menu)';
        case CHIP_COLORS.REJECTED:
            return 'var(--color-neutral-1-white)';
        case CHIP_COLORS.DONE:
            return 'var(--color-neutral-1-white)';
        case CHIP_COLORS.SHIPMENT_RECEIVED:
            return 'var(--color-neutral-1-white)';
        case CHIP_COLORS.VALIDATED:
            return 'var(--color-accent-3-10)';
        default:
            return undefined;
    }
}
function getFontColor(chipColor: CHIP_COLORS){
    switch(chipColor){
        case CHIP_COLORS.GREEN:
            return FONT_COLOR.SEMANTIC_1;
        case CHIP_COLORS.BLUE:
            return FONT_COLOR.ACCENT1;
        case CHIP_COLORS.ORANGE:
            return FONT_COLOR.ACCENT4;
        case CHIP_COLORS.RED:
            return FONT_COLOR.ACCENT3;
        case CHIP_COLORS.PURPLE:
            return FONT_COLOR.ACCENT2;
        case CHIP_COLORS.PENDING:
            return FONT_COLOR.NEUTRAL11_MENU;
        case CHIP_COLORS.APPROVED:
            return FONT_COLOR.NEUTRAL11_MENU;
        case CHIP_COLORS.CANCELLED:
            return FONT_COLOR.NEUTRAL11_MENU;
        case CHIP_COLORS.REJECTED:
            return FONT_COLOR.NEUTRAL_1_WHITE;
        case CHIP_COLORS.DONE:
            return FONT_COLOR.NEUTRAL_1_WHITE;
        case CHIP_COLORS.SHIPMENT_RECEIVED:
            return FONT_COLOR.NEUTRAL_1_WHITE;
        case CHIP_COLORS.VALIDATED:
            return FONT_COLOR.NEUTRAL11_MENU;
        default:
            return undefined;
    }
}
export default Chip;